@if (!isMobile) {
  <div class="section-top-header ui-mobile-AirDisc">{{
  'dataExtractionRquest.dataExtractionRquestTitle' | cxTranslate }}</div>
}
@if (isMobile) {
  <div class="section-top-header ui-mobile-AirDisc" (click)="iconToggler =! iconToggler">{{
  'dataExtractionRquest.dataExtractionRquestTitle' | cxTranslate }}</div>
}
@if (isMobile?!iconToggler:true) {
  <ul class="my-account-nav mobile-account-nav">
    <li class="parentLI">
      <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'dataExtractionOverview'?'active':''"
        href="#dataExtractionOverview" (click)="SelectedComponent('dataExtractionOverview',$event)">{{
        'dataExtractionRquest.dataExtractionOverview' | cxTranslate }}
        @if (currentComponent === 'dataExtractionOverview') {
          <img src="/icons/link-right-blue.svg"
            class="right-arrow">
        }</a>
      </li>
      <li class="parentLI">
        <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'customerVehicleOwner'?'active':''"
          href="#customerVehicleOwner" (click)="SelectedComponent('customerVehicleOwner',$event)">
          {{ 'dataExtractionRquest.customerVehicleOwner' | cxTranslate
          }}
          @if (currentComponent === 'customerVehicleOwner') {
            <img src="/icons/link-right-blue.svg"
              class="right-arrow">
          }</a>
        </li>
        <li class="parentLI">
          <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'requestor'?'active':''" href="#requestor"
            (click)="SelectedComponent('requestor',$event)">{{ 'dataExtractionRquest.requestor' | cxTranslate }}
            @if (currentComponent === 'requestor') {
              <img src="/icons/link-right-blue.svg" class="right-arrow">
            }</a>
          </li>
          <li class="parentLI">
            <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'reportECURecipient'?'active':''"
              href="#reportECURecipient" (click)="SelectedComponent('reportECURecipient',$event)">{{
              'dataExtractionRquest.reportECURecipient' | cxTranslate }}
              @if (currentComponent === 'reportECURecipient') {
                <img src="/icons/link-right-blue.svg"
                  class="right-arrow">
              }</a>
            </li>
            <li class="parentLI">
              <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'vehicleInformation'?'active':''"
                href="#vehicleInformation" (click)="SelectedComponent('vehicleInformation',$event)">{{
                'dataExtractionRquest.vehicleInformation' | cxTranslate }}
                @if (currentComponent === 'vehicleInformation') {
                  <img src="/icons/link-right-blue.svg"
                    class="right-arrow">
                }</a>
              </li>
              <li class="parentLI">
                <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'eCUInformation'?'active':''"
                  href="#eCUInformation" (click)="SelectedComponent('eCUInformation',$event)">{{
                  'dataExtractionRquest.eCUInformation' | cxTranslate }}
                  @if (currentComponent === 'eCUInformation') {
                    <img src="/icons/link-right-blue.svg" class="right-arrow">
                  }</a>
                </li>
                <li class="parentLI">
                  <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'incidentInformation'?'active':''"
                    href="#incidentInformation" (click)="SelectedComponent('incidentInformation',$event)">{{
                    'dataExtractionRquest.incidentInformation' | cxTranslate }}
                    @if (currentComponent === 'incidentInformation') {
                      <img src="/icons/link-right-blue.svg"
                        class="right-arrow">
                    }</a>
                  </li>
                  <li class="parentLI">
                    <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'returnShippingInformation'?'active':''"
                      href="#returnShippingInformation" (click)="SelectedComponent('returnShippingInformation',$event)">{{
                      'dataExtractionRquest.returnShippingInformation' | cxTranslate }}
                      @if (currentComponent === 'returnShippingInformation') {
                        <img src="/icons/link-right-blue.svg"
                          class="right-arrow">
                      }</a>
                    </li>
                  </ul>
                }